export default function(referenceData) {
  function createErrorFunction(refData) {
    let errors = {};
    for (let properties in refData) {
      if (refData[properties] instanceof Array) {
        errors[properties] = [];
        for (let indexArray in refData[properties]) {
          errors[properties][indexArray] = createErrorFunction(refData[properties][indexArray]);
        }
      } else {
        errors[properties] = [];
      }
    }
    return errors;
  }

  return createErrorFunction(referenceData);
}
